import { Field as BaseField } from 'components/Wizards/Field/Field'
import { BrandKitField } from 'components/Wizards/Wizard/Form/BrandKitField/BrandKitField'
import { SnippetTypeaheadInput } from 'components/Wizards/Wizard/Form/SnippetTypeaheadInput'
import { FieldSchema } from 'components/Wizards/Wizard/Form/Types'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import Styles from './DesktopTopic.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ConditionalLanguageInputField as LanguageInputField } from '../../Wizard/Form/LanguageInputField/ConditionalLanguageInputField'

interface Props {
  topicSchema: FieldSchema
  textPostEntrypoint?: ChannelType
}

export const DesktopTopic = ({ topicSchema, textPostEntrypoint }: Props) => {
  const { nullable, optional, meta } = topicSchema.describe()
  const isRequired = !nullable && !optional

  const isBrandKitsEnabled = useFlipperFlag('brand_kits')

  return (
    <BaseField name="topic" label={meta.label} direction="column" isRequired={isRequired}>
      <SnippetTypeaheadInput
        name="topic"
        schema={topicSchema}
        autoFocus
        actions={
          <div className={Styles.rightContent}>
            {textPostEntrypoint && (
              <div className={Styles.languageField}>
                <div className={Styles.label}>
                  <Text variant="secondary" color="var(--dark-40)">
                    Language
                  </Text>
                </div>
                <div className={Styles.languageFieldButton}>
                  <LanguageInputField label="" />
                </div>
              </div>
            )}
            {isBrandKitsEnabled && (
              <div className={Styles.brandKitField}>
                <div className={Styles.label}>
                  <Text variant="secondary" color="var(--dark-40)">
                    Brand Kit
                  </Text>
                </div>
                <div className={Styles.brandKitFieldButton}>
                  <BrandKitField size="sm" />
                </div>
              </div>
            )}
          </div>
        }
      />
    </BaseField>
  )
}
